import { resolveSupportPhone } from '@provision/formatting-utils';
import type { LandingPagePartner } from '@provision/landing-page-ui';
import { formatToPhoneNumber } from 'src/components/FormattedPhoneInput/format-to-phone-number';
import type { BrandWithSupport } from 'src/graphql';

/** The footer's contact details: the brand group's client-facing pair, not its internal routing. */
export function toLandingPagePartner(
  segment: BrandWithSupport | undefined,
  termsOfServiceUrl: string | undefined,
): LandingPagePartner {
  const group = segment?.brandGroup;

  return {
    name: segment?.name ?? undefined,
    phone:
      resolveSupportPhone({
        fwdPhonePublished: group?.fwdPhonePublished,
        fwdPhonePublishedExt: group?.fwdPhonePublishedExt,
        fwdPhoneSupport: group?.fwdPhoneSupport,
        formatPhoneNumber: formatToPhoneNumber,
      }) ?? undefined,
    email: group?.membershipEmail || group?.supportEmail || undefined,
    termsOfServiceUrl: termsOfServiceUrl?.trim() || undefined,
  };
}
